import { render, staticRenderFns } from "./ModalManufacturings.vue?vue&type=template&id=2bbefc9b&lang=pug&"
import script from "./ModalManufacturings.vue?vue&type=script&lang=js&"
export * from "./ModalManufacturings.vue?vue&type=script&lang=js&"
import style0 from "./ModalManufacturings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports